const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}

/**
 * Escape a value for interpolation into an HTML string.
 *
 * @param {*} value - Coerced to string; null/undefined become ''
 * @returns {string} Safe for element content or an attribute value
 */
export function escapeHtml (value) {
  if (value === null || value === undefined) {
    return ''
  }

  return String(value).replace(/[&<>"']/g, char => HTML_ESCAPES[char])
}

/** CSS colours we are willing to inline into a style attribute. */
const SAFE_COLOR = /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%]+\)|hsla?\([\d\s.,%deg]+\)|[a-z]+)$/i

/**
 * Returns the value if it is a plain CSS colour. Returns null if it is not.
 * A stored value that is not a colour can close a style attribute.
 *
 * @param {string} value
 * @returns {string|null}
 */
export function safeCssColor (value) {
  if (typeof value !== 'string') {
    return null
  }

  const trimmed = value.trim()
  return SAFE_COLOR.test(trimmed) ? trimmed : null
}
